import Vue from 'vue'

export const storeUserPass = Vue.observable({
  userPassExpired: {
    p: ''
  }
})
export const mutationUserPass = {
  setPExpired: p => {
    storeUserPass.userPassExpired.p = p
  }
}
